import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { setOrCreateNewActiveLayer, removeActiveLayer } from '../../../../redux/active_layers/Actions';
import { setMapProperties } from '../../../../redux/map/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';

import QuickSelect from './QuickSelect';

const propTypes = {
    layer: PropTypes.object.isRequired
};

function LayerQuickSelect ({ layer }) {
    const dispatch = useDispatch();
    const dispatchSetOrCreateNewActiveLayer = (layer, styling) => dispatch(setOrCreateNewActiveLayer(layer, styling));
    const dispatchSetMapProperties = (properties) => dispatch(setMapProperties(properties, MAIN_MAP));
    const dispatchRemoveActiveLayer = (systemName) => dispatch(removeActiveLayer(systemName));
    const activeLayer = useSelector(state => state.activeLayers.find(e => e.uid === layer.system_name));
    const settings = useSelector(state => state.layerSettingsReducer.find(setting => setting.uid === layer.system_name));

    function toggleLayer (e) {
        if (e.target.checked) {
            dispatchSetOrCreateNewActiveLayer({
                uid: layer.system_name,
                systemName: layer.system_name,
                visible: true,
                printable: true
            }, layer);
            dispatchSetMapProperties({ zoom: [layer.styles[(settings && settings.currentStyleIdx) || 0].mapboxStyleSpecification.source.minzoom + 1] });
        } else {
            dispatchRemoveActiveLayer(layer.system_name);
        }
    }

    return (
        <QuickSelect
            layer={layer}
            filters={settings && settings.filters}
            isActive={Boolean(activeLayer)}
            onToggleActive={toggleLayer}
        />
    );
}

LayerQuickSelect.propTypes = propTypes;

export default LayerQuickSelect;